import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import { MatIconModule } from '@angular/material/icon';
import { TranslationModule } from '@galaxy/crm/static';
import { PermissionRequiredComponent } from './permission-required.component';

@Component({
  selector: 'crm-permission-required-panel',
  templateUrl: './permission-required-panel.component.html',
  styleUrls: ['./permission-required.component.scss'],
  imports: [MatButtonModule, GalaxyPageModule, GalaxyEmptyStateModule, MatIconModule, TranslationModule],
  standalone: true,
})
export class PermissionRequiredPanelComponent extends PermissionRequiredComponent {}
